export var onlyLettersMixin = {
    methods: {
        onlyLetters: function onlyLetters(evt) {
            evt = evt || window.event;
            var charCode = evt.which || evt.keyCode;
            if (charCode > 32 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122)) {
                evt.preventDefault();
            } else {
                return true;
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/mixins/only-letters.js
// module id = ./src/mixins/only-letters.js
// module chunks = 34